var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('form', [_vm.initialLoading ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _c('div', [_vm.successfully ? _c('h2', {
    staticClass: "motto-blue-text mb-35"
  }, [_vm._v("Personal email change has been confirmed!")]) : _vm._e(), _vm.loggedIn ? _c('BaseLink', {
    attrs: {
      "to": {
        name: 'myInfo'
      }
    }
  }, [_c('BaseButton', {
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Go to Profile Page")])])], 1) : _c('BaseLink', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('BaseButton', {
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v("Go to Home Page")])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }